import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { BsEye, BsPencilSquare, BsTrash } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

interface Item {
  id: number;
  Year: string;
  Artist: string;
  Category: string;
  Title: string;
  Media: string;
  DatePosted: string;
  Link: string;
  Thumbnail: string;
  // Add more properties as per your item structure
}

interface currentLatestTableProps {
  items: Item[];
  onDelete: (id: number) => void;
  onEdit: (id: number) => void; // Add onEdit prop
}

export default function CurrentLatestTable({
  items,
  onDelete,
  onEdit, // Destructure onEdit
}: currentLatestTableProps) {
  const [latestPage, setLatestPage] = useState(1);

  const latestPerPage = 10;

  const indexOfLastLatest = latestPage * latestPerPage;
  const indexOfFirstLatest = indexOfLastLatest - latestPerPage;
  const currentLatest = items
    ? items.slice(indexOfFirstLatest, indexOfLastLatest)
    : [];
  const totalPages = items ? Math.ceil(items.length / latestPerPage) : 1;

  const nextLatestPage = () => {
    if (latestPage < totalPages) {
      setLatestPage(latestPage + 1);
    }
  };

  const prevLatestPage = () => {
    if (latestPage > 1) {
      setLatestPage(latestPage - 1);
    }
  };

  return (
    <>
      <Table hover>
        <thead className="bg-gray-200">
          <tr>
            <th>Year</th>
            <th>Artist</th>
            <th>Category</th>
            <th>Title</th>
            <th>Media</th>
            <th>Date posted</th>
            <th>Link</th>
            <th>Thumbnail</th>
            <th>Actions</th> {/* Add Actions column */}
          </tr>
        </thead>
        <tbody>
          {currentLatest.map((item) => (
            <tr key={item.id}>
              <td>{item.Year}</td>
              <td>{item.Artist}</td>
              <td>{item.Category}</td>
              <td>{item.Title}</td>
              <td>{item.Media}</td>
              <td>{item.DatePosted}</td>
              <td>{item.Link}</td>
              <td>{item.Thumbnail}</td>
              <td className="flex justify-center items-center space-x-2">
                <button
                  onClick={() => {
                    console.log("Edit button clicked for ID:", item.id);
                    onEdit(item.id);
                  }}
                  type="button"
                  className="bg-blue-600 rounded-sm text-white text-xl mr-2 flex items-center justify-center"
                >
                  <BsPencilSquare className="mr-1" />
                </button>
                <button
                  onClick={() => onDelete(item.id)}
                  type="button"
                  className="bg-gray-600 rounded-sm text-white text-xl"
                  data-tooltip-id="delete"
                >
                  <BsTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="flex justify-center items-center mt-4 space-x-4">
        <button
          onClick={prevLatestPage}
          className="px-4 py-2 rounded disabled:opacity-50 text-white bg-gray-500"
          disabled={latestPage === 1}
        >
          Previous
        </button>
        <button
          onClick={nextLatestPage}
          className="px-4 py-2 rounded disabled:opacity-50 bg-red-500"
          disabled={
            latestPage === Math.ceil((items ? items.length : 0) / latestPerPage)
          }
        >
          Next
        </button>
      </div>
    </>
  );
}
